import { Link } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PartnerRouteHelper } from 'routes/partner';

export const NoSelectableOutsideLaboratory = () => {
  const navigate = useNavigate();

  return (
    <div>
      登録可能な顧客がいません。
      <Link
        onClick={() =>
          navigate(
            PartnerRouteHelper.settingShow(), // パスは文字列
            {
              state: { settingItemKey: 'outsideLaboratories' }, // state は第2引数
            }
          )
        }
      >
        外部顧客を追加するにはこちら。
      </Link>
    </div>
  );
};
